import clsx from "clsx";

interface ToggleButtonProps {
	propertyType: "active" | "sold" | "de_listed";
	togglesPropertyType: Record<string, boolean>;
	togglePropertyTypeButton: (propertyType: string) => void;
}
const ToggleButton = ({
	propertyType,
	togglesPropertyType,
	togglePropertyTypeButton,
}: ToggleButtonProps) => {
	const isOn = togglesPropertyType[propertyType];

	const getColor = () => {
		switch (propertyType) {
			case "active":
				return "bg-[#456930]";
			case "sold":
				return "bg-[#C10230]";
			default:
				return "bg-[#32302F]";
		}
	};

	return (
		<button
			type="button"
			onClick={() => togglePropertyTypeButton(propertyType)}
			className={clsx(
				"w-[60px] h-8 flex items-center rounded-full p-1 transition-colors duration-300",
				isOn ? getColor() : "bg-[#CDCDCD]",
			)}
		>
			<div
				className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform duration-300 ${
					isOn ? "translate-x-7" : "translate-x-0"
				}`}
			/>
		</button>
	);
};

export { ToggleButton };
